module.exports = __webpack_public_path__ + "img/incorrect_btn.7ffa84c1.png";